export * from './widgets/common/accordion/accordion.build';
export * from './widgets/common/accordion/accordion-pane/accordion-pane.build';
export * from './widgets/common/tabs/tabs.build';
export * from './widgets/common/tabs/tab-pane/tab-pane.build';
export * from './widgets/common/anchor/anchor.build';
export * from './widgets/common/audio/audio.build';
export * from './widgets/common/breadcrumb/breadcrumb.build';
export * from './widgets/common/button-group/button-group.build';
export * from './widgets/common/button/button.build';
export * from './widgets/common/calendar/calendar.build';
export * from './widgets/common/card/card.build';
export * from './widgets/common/card/card-content/card-content.build';
export * from './widgets/common/card/card-actions/card-actions.build';
export * from './widgets/common/card/card-footer/card-footer.build';
export * from './widgets/common/carousel/carousel.build';
export * from './widgets/common/carousel/carousel-template/carousel-template.build';
export * from './widgets/common/chart/chart.build';
export * from './widgets/common/checkbox/checkbox.build';
export * from './widgets/common/checkboxset/checkboxset.build';
export * from './widgets/common/chips/chips.build';
export * from './widgets/common/color-picker/color-picker.build';
export * from './widgets/common/composite/composite.build';
export * from './widgets/common/container/container.build';
export * from './widgets/common/content/content.build';
export * from './widgets/common/currency/currency.build';
export * from './widgets/common/date-time/date-time.build';
export * from './widgets/common/date/date.build';
export * from './widgets/common/dialog/alert-dialog/alert-dialog.build';
export * from './widgets/common/dialog/confirm-dialog/confirm-dialog.build';
export * from './widgets/common/dialog/base/dialog-footer/dialog-footer.build';
export * from './widgets/common/dialog/design-dialog/dialog.build';
export * from './widgets/common/dialog/iframe-dialog/iframe-dialog.build';
export * from './widgets/common/dialog/login-dialog/login-dialog.build';
export * from './widgets/common/dialog/partial-dialog/partial-dialog.build';
export * from './widgets/common/footer/footer.build';
export * from './widgets/common/form/form-field/form-field.build';
export * from './widgets/common/form/form-action/form-action.build';
export * from './widgets/common/form/form.build';
export * from './widgets/common/header/header.build';
export * from './widgets/common/html/html.build';
export * from './widgets/common/icon/icon.build';
export * from './widgets/common/iframe/iframe.build';
export * from './widgets/common/label/label.build';
export * from './widgets/common/list/list.build';
export * from './widgets/common/layout-grid/layout-grid-column/layout-grid-column.build';
export * from './widgets/common/layout-grid/layout-grid-row/layout-grid-row.build';
export * from './widgets/common/layout-grid/layout-grid.build';
export * from './widgets/common/left-panel/left-panel.build';
export * from './widgets/common/live-table/live-table.build';
export * from './widgets/common/login/login.build';
export * from './widgets/common/marquee/marquee.build';
export * from './widgets/common/message/message.build';
export * from './widgets/common/menu/menu.build';
export * from './widgets/common/nav/nav-item/nav-item.build';
export * from './widgets/common/nav/nav.build';
export * from './widgets/common/navbar/navbar.build';
export * from './widgets/common/number/number.build';
export * from './widgets/common/page-content/page-content.build';
export * from './widgets/common/page/page.build';
export * from './widgets/common/pagination/pagination.build';
export * from './widgets/common/panel/panel.build';
export * from './widgets/common/partial/partial.build';
export * from './widgets/common/partial-param/partial-param.build';
export * from './widgets/common/picture/picture.build';
export * from './widgets/common/popover/popover.build';
export * from './widgets/common/prefab/prefab.build';
export * from './widgets/common/prefab-container/prefab-container.build';
export * from './widgets/common/progress-bar/progress-bar.build';
export * from './widgets/common/progress-bar/progress-circle/progress-circle.build';
export * from './widgets/common/radioset/radioset.build';
export * from './widgets/common/rating/rating.build';
export * from './widgets/common/rich-text-editor/rich-text-editor.build';
export * from './widgets/common/right-panel/right-panel.build';
export * from './widgets/common/search/search.build';
export * from './widgets/common/select/select.build';
export * from './widgets/common/slider/slider.build';
export * from './widgets/common/spinner/spinner.build';
export * from './widgets/common/switch/switch.build';
export * from './widgets/common/table/table-action/table-action.build';
export * from './widgets/common/table/table-column-group/table-column-group.build';
export * from './widgets/common/table/table-column/table-column.build';
export * from './widgets/common/table/table-row/table-row.build';
export * from './widgets/common/table/table-row-action/table-row-action.build';
export * from './widgets/common/table/table.build';
export * from './widgets/common/text/text.build';
export * from './widgets/common/textarea/textarea.build';
export * from './widgets/common/tile/tile.build';
export * from './widgets/common/time/time.build';
export * from './widgets/common/tree/tree.build';
export * from './widgets/common/top-nav/top-nav.build';
export * from './widgets/common/video/video.build';
export * from './widgets/common/wizard/wizard.build';
export * from './widgets/common/wizard/wizard-step/wizard-step.build';
export * from './widgets/common/file-upload/file-upload.build';

export * from '@wm/transpiler';

export const initComponentsBuildTask = () => {};
